var AdviceFactory = function ($resource, $http, $q, $window) {
    var getFeSamlTokenApi = "/participant-web-services/rest/sso/femaSaml";
    var getFeSamlTokenForPlanApi =
        "/participant-web-services/rest/sso/femaSaml/indId/:individualId/group/:groupId";
    var getTasSSOApi =
        "/participant-web-services/rest/sso/tasSSO/indId/:individualId/group/:groupId";

    var getMAEnrollmentDataApi =
        "/participant-web-services/rest/investments/ma/getManagedAccountEnrollmentData/:groupId";

    var getWhatItCostsDataApi =
        "/participant-web-services/rest/enrollment/getWhatItCostsData/:groupId";

    var getLegalDocsApi = "/participant-web-services/rest/enrollment/getLegalDocs/:groupId";

    var getMStarPlanDetailsApi =
        "/participant-web-services/rest/investments/ma/getMStarPlanDetailsData";

    var getFeSamlTokenParams = {
        individualId: "@individualId",
        groupId: "@groupId",
        clickthrough: "@clickthrough",
        pagecode: "@pagecode",
        treatment: "@treatment",
        lastAlert: "@lastAlert"
    };

    var getTasSSOServiceUrlParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    var getMAEnrollmentDataParams = {
        groupId: "@groupId"
    };

    var getWhatItCostsDataParams = {
        groupId: "@groupId"
    };

    var getLegalDocsParams = {
        groupId: "@groupId"
    };

    return {
        getMStarPlanDetails: $resource(
            __baseApiUrl__ + getMStarPlanDetailsApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true
                }
            }
        ),

        getFeSamlTokenForPlan: $resource(
            __baseApiUrl__ + getFeSamlTokenForPlanApi,
            getFeSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getFeSamlToken: $resource(
            __baseApiUrl__ + getFeSamlTokenApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getTasSSOServiceUrl: $resource(__baseApiUrl__ + getTasSSOApi, getTasSSOServiceUrlParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),

        getMAEnrollmentData: $resource(
            __baseApiUrl__ + getMAEnrollmentDataApi,
            getMAEnrollmentDataParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getWhatItCostsData: $resource(
            __baseApiUrl__ + getWhatItCostsDataApi,
            getWhatItCostsDataParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getLegalDocsUrl: $resource(__baseApiUrl__ + getLegalDocsApi, getLegalDocsParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),

        saveMAEnrollmentData: function (maRequest) {
            var deferred = $q.defer();
            $http
                .post(
                    __baseApiUrl__ +
                        "/participant-web-services/rest/investments/ma/saveManagedAccountEnrollment/" +
                        maRequest.groupId,
                    maRequest
                )
                .success(function (data, status, headers, config) {
                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config, statusText) {
                    deferred.reject();
                });

            return deferred.promise;
        },

        getToken: function () {
            var req = {
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/rivLandingSamlService/getRIVLandingSamlResponse",
                method: "GET",
                crossDomain: true,
                isArray: false,
                headers: {
                    "Content-Type": "application/json"
                }
            };
            return $http(req);
        },

        getMTRLambdaBaseURI: function () {
            var req = {
                url:
                    __baseApiUrl__ +
                    "/participant-web-services/rest/rivLandingSamlService/getMigratedContextUrls",
                method: "GET",
                crossDomain: true,
                isArray: false,
                headers: {
                    "Content-Type": "application/json"
                }
            };
            return $http(req);
        },

        getMaxID: function (samlToken, url) {
            var req = {
                url: url + "/managedAccountParticipants/dashboard/entry",
                method: "POST",
                crossDomain: true,
                isArray: false,
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    samlToken: samlToken
                }
            };
            return $http(req);
        },

        saveAdviceEnroll: function (data, url) {
            var req = {
                url: url + "/managedAccountParticipants/adviceDashboard/entry",
                method: "POST",
                crossDomain: true,
                isArray: false,
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data)
            };
            return $http(req);
        }
    }; // End of return
};

AdviceFactory.$inject = ["$resource", "$http", "$q", "$window"];
export default AdviceFactory;
